import { Component, Input } from '@angular/core';
import { UtilityService } from '../../../core/services/utility.service';

@Component({
    selector: 'course-list',
    templateUrl: './course-list.component.html',
    styleUrls: ['./course-list.component.scss'],
    standalone: false
})
export class CourseListComponent {

    @Input() courses: any[];
    @Input() people: any[];
    @Input() column: string;
    @Input() pagename: string;
   
    public courseDescriptions: any[] = [];
    public moreorless: any[] = [];
    
    constructor(public utility: UtilityService) {        
    }

    toggleDesc(courseId) {
        this.courseDescriptions[courseId] = !this.courseDescriptions[courseId];        
        if (this.courseDescriptions[courseId]) {
            this.moreorless[courseId] = 'less';
        } else {
            this.moreorless[courseId] = 'more';
        }
    }
}
